import { createSlice } from "@reduxjs/toolkit"

const currentUserSlice = createSlice({
  name: "currentUser",
  initialState: {
    currentUser: null,
    loading: false,
    dataFetched: false,
    isValidRedirectUrl: false,
    urlLoading: false
  },
  reducers: {
    getCurrentUser(state) {
      return {
        ...state,
        loading: true,
      }
    },
    setCurrentUser(state, action) {
      return {
        ...state,
        currentUser: action.payload.data,
        loading: false,
        dataFetched: true,
      }
    },
    getValidRedirectUrls(state) {
      return {
        ...state,
        loading: true,
      }
    },
    getValidRedirectUrlsSuccess(state, { payload }) {
      console.log(payload.data)
      return {
        ...state,
        isValidRedirectUrl: payload.data.data,
        loading: false,
        urlLoading: true,
        dataFetched: true,
      }
    }
  },
})

export const { getCurrentUser, setCurrentUser, getValidRedirectUrls, getValidRedirectUrlsSuccess } = currentUserSlice.actions

export default currentUserSlice.reducer
